/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
function lerp2(x0, y0, x1, y1, x) {
  if (x1 == x0) return y0;
  return y0 + (y1 - y0) * (x - x0) / (x1 - x0);
}

Array.from(document.querySelectorAll('input[type=range]')).forEach((el) => {
  const value = el.value,
        min   = el.getAttribute('min'),
        max   = el.getAttribute('max');
  let left         = `${lerp2(min, 0, max, 100, value)}%`,
      thumb_offset = `${lerp2(min, 10, max, -10, value)}px`;
  el.nextElementSibling.innerHTML = value;
  el.nextElementSibling.style.left = `calc(${left} + (${thumb_offset}))`;

  el.addEventListener('input', e => {
    e.preventDefault();
    const $current = e.currentTarget;
    const value = $current.value,
          min   = $current.getAttribute('min'),
          max   = $current.getAttribute('max');
    let left         = `${lerp2(min, 0, max, 100, value)}%`,
        thumb_offset = `${lerp2(min, 10, max, -10, value)}px`;
    el.nextElementSibling.innerHTML = value;
    el.nextElementSibling.style.left = `calc(${left} + (${thumb_offset}))`;
  })
})

if (window.matchMedia("(min-width: 1008px)").matches) {
  $(function(){
    $('.main-slider').slick({
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
      infinite: false,
      pauseOnHover: false,
      asNavFor:'.sub-slider',
    });
    $('.sub-slider').slick({
        asNavFor:'.main-slider',
        infinite: false,
        focusOnSelect: true,
        slidesToShow:7,
        slidesToScroll:1,
        arrows:false,
    });
  });
}

if (window.matchMedia("(max-width: 1007px)").matches) {
  $(function(){
    $('.main-slider').slick({
      prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"></button>',
      nextArrow: '<button class="slick-next" aria-label="Next" type="button"></button>',
      infinite: false,
      pauseOnHover: false,
      asNavFor:'.sub-slider',
    });
    $('.sub-slider').slick({
        asNavFor:'.main-slider',
        infinite: false,
        focusOnSelect: true,
        slidesToShow:4,
        slidesToScroll:1,
        arrows:false,
    });
  });
}